import type { PointNumber, ResolveFn } from '../types.js';

export function oddsPayoutPass(stake: number, point: PointNumber): number {
  if (point === 4 || point === 10) return stake * 2;
  if (point === 5 || point === 9) return Math.floor(stake * 3 / 2);
  return Math.floor(stake * 6 / 5);
}

export function oddsPayoutDont(stake: number, point: PointNumber): number {
  if (point === 4 || point === 10) return Math.floor(stake / 2);
  if (point === 5 || point === 9) return Math.floor(stake * 2 / 3);
  return Math.floor(stake * 5 / 6);
}

type RideResult =
  | { kind: 'no-number' }
  | { kind: 'numberHit'; number: PointNumber }
  | { kind: 'seven'; number: PointNumber }
  | { kind: 'other'; number: PointNumber };

const ridesParent = (b: { number?: PointNumber }, roll: { total: number }): RideResult => {
  if (b.number === undefined) return { kind: 'no-number' };
  if (roll.total === b.number) return { kind: 'numberHit', number: b.number };
  if (roll.total === 7) return { kind: 'seven', number: b.number };
  return { kind: 'other', number: b.number };
};

export const resolveOdds: ResolveFn = (b, roll) => {
  const result = ridesParent(b, roll);
  if (result.kind === 'no-number') return { betId: b.id, outcome: 'continue', payout: 0 };
  if (result.kind === 'numberHit') {
    return { betId: b.id, outcome: 'win', payout: oddsPayoutPass(b.amount, result.number) };
  }
  if (result.kind === 'seven') return { betId: b.id, outcome: 'lose', payout: 0 };
  return { betId: b.id, outcome: 'continue', payout: 0 };
};

export const resolveDontOdds: ResolveFn = (b, roll) => {
  const result = ridesParent(b, roll);
  if (result.kind === 'no-number') return { betId: b.id, outcome: 'continue', payout: 0 };
  if (result.kind === 'seven') {
    return { betId: b.id, outcome: 'win', payout: oddsPayoutDont(b.amount, result.number) };
  }
  if (result.kind === 'numberHit') return { betId: b.id, outcome: 'lose', payout: 0 };
  return { betId: b.id, outcome: 'continue', payout: 0 };
};
